import pako from 'pako';

// Browser-safe Base64 <-> Uint8Array
export const base64ToUint8Array = (base64) => {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
};

export const uint8ArrayToBase64 = (bytes) => {
  let binary = '';
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
};

// Compress object to Base64
export const compressData = (obj) => {
  const str = JSON.stringify(obj);
  const compressed = pako.gzip(str);
  return uint8ArrayToBase64(compressed);
};

// Decompress Base64 to object
export const decompressData = (docData) => {
  if (docData && docData.compressed && typeof docData.compressed === 'string') {
    try {
      const byteArray = base64ToUint8Array(docData.compressed);
      if (byteArray[0] === 0x1f && byteArray[1] === 0x8b) {
        const decompressedStr = pako.ungzip(byteArray, { to: 'string' });
        return JSON.parse(decompressedStr);
      }
    } catch (e) {
      console.warn('Failed to decompress:', e);
    }
  }
  return docData;
};

export const normalizeTimestamp = (timestamp) => {
  if (
    timestamp &&
    typeof timestamp === 'object' &&
    '_seconds' in timestamp &&
    '_nanoseconds' in timestamp
  ) {
    return { seconds: timestamp._seconds, nanoseconds: timestamp._nanoseconds };
  }

  return timestamp;
};
